<div class="v2token-validation">
  <h2>Validating your token...</h2>

  <div *ngIf="successMessage" class="success-message">
    <p>{{ successMessage }}</p>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    <p>{{ errorMessage }}</p>
    <a routerLink="/v2" class="retry-link">Request a new login link</a>
  </div>
</div>